import { useSearchParams } from "react-router-dom";
import SectionHeader from "../../../components/section/SectionHeader";
import SectionTitle from "../../../components/section/SectionTitle";
import PushNotificationHistoryTable from "../../../components/push-notification/PushNotificationHistoryTable";
import PushFeedback from "../../../components/push-notification/PushFeedback";
import { usePushNotificationJobs } from "../../../hooks/push-notifications";

const statuses = [
  "SCHEDULED",
  "PREPARING",
  "QUEUED",
  "PROCESSING",
  "SUCCEEDED",
  "PARTIALLY_SUCCEEDED",
  "FAILED",
  "CANCELLED",
];

function PushNotificationHistory() {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = {
    status: searchParams.get("status") ?? "",
    category: searchParams.get("category") ?? "",
    search: searchParams.get("search") ?? "",
    page: Number(searchParams.get("page") ?? 0),
    pageSize: 20,
  };
  const jobs = usePushNotificationJobs(filters);

  const setFilter = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value) next.set(key, value);
    else next.delete(key);
    if (key !== "page") next.delete("page");
    setSearchParams(next);
  };

  return (
    <div className="relative mb-6 flex w-full min-w-0 flex-col break-words rounded bg-white p-2 shadow-lg">
      <div className="rounded-t border-0 px-4 py-3 pb-6">
        <SectionHeader>
          <SectionTitle title="Push notification history" />
        </SectionHeader>
      </div>
      <div className="mb-6 grid gap-4 px-4 sm:grid-cols-2 lg:grid-cols-3">
        <label className="text-sm font-semibold">
          Search
          <input
            aria-label="Search history"
            value={filters.search}
            onChange={(event) => setFilter("search", event.target.value)}
            className="mt-2 w-full rounded border border-slate-200 px-3 py-2 font-normal"
          />
        </label>
        <label className="text-sm font-semibold">
          Status
          <select
            aria-label="Status"
            value={filters.status}
            onChange={(event) => setFilter("status", event.target.value)}
            className="mt-2 w-full rounded border border-slate-200 bg-white px-3 py-2 font-normal"
          >
            <option value="">All statuses</option>
            {statuses.map((status) => <option key={status}>{status}</option>)}
          </select>
        </label>
        <label className="text-sm font-semibold">
          Category
          <select
            aria-label="Category"
            value={filters.category}
            onChange={(event) => setFilter("category", event.target.value)}
            className="mt-2 w-full rounded border border-slate-200 bg-white px-3 py-2 font-normal"
          >
            <option value="">All categories</option>
            {["PROMOTION", "LOYALTY", "TRANSACTIONAL"].map((category) => (
              <option key={category}>{category}</option>
            ))}
          </select>
        </label>
      </div>
      <PushFeedback errors={jobs.error ? [jobs.error.message] : []} />
      <PushNotificationHistoryTable
        response={jobs.data}
        loading={jobs.isLoading}
        onPage={(page) => setFilter("page", String(page))}
      />
    </div>
  );
}

export default PushNotificationHistory;
